import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  base: window.location.pathname,
  mode: 'history',
});

Vue.config.productionTip = false;
const mountEl = document.getElementById('ug-programme-search');
const year = mountEl.dataset.year;


Vue.use(CludoVue, {
  store: store,
  router: router,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 12211,
    // cludoEngineId: 11278, // Course/Programme Engine ID
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 500,
    paginationRange: 2,
    sortOnLoad: { "ProgrammeTitle": 'asc' },
    payload: {
      filters: {
        Category: ['Undergraduate'],
        StudyLevel: ['Undergraduate'],
        StudyYear: ['2026', '2027'],
      },
      // postFiltersOperator: 'or',
    },
  },
});

new Vue({
  render: (h) =>
    h(App, {
      props: {
        year: year,
      },
    }),
  store,
  router,
}).$mount('#ug-programme-search');
